/** Contacts  */
export const FETCH_CONTACTS_SUCCESS = "FETCH_CONTACTS_SUCCESS";
export const FETCH_CONTACTS_LOADING = "FETCH_CONTACTS_LOADING";
export const FETCH_CONTACTS_ERROR = "FETCH_CONTACTS_ERROR";

export const RESET_CONTACTS = "RESET_CONTACTS";
export const FETCH_MORE_CONTACTS_SUCCESS = "FETCH_MORE_CONTACTS_SUCCESS";

/** Messages  */
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS";
export const FETCH_MESSAGES_LOADING = "FETCH_MESSAGES_LOADING";
export const FETCH_MESSAGES_ERROR = "FETCH_MESSAGES_ERROR";

export const RESET_MESSAGES = "RESET_MESSAGES";
export const FETCH_MORE_MESSAGES_SUCCESS = "FETCH_MORE_MESSAGES_SUCCESS";
export const FETCH_MORE_MESSAGES_LOADING = "FETCH_MORE_MESSAGES_LOADING";
export const SET_CHAT_MESSAGE = "SET_CHAT_MESSAGE";
export const SET_CHAT_PHONE_NO = "SET_CHAT_PHONE_NO";
export const FETCH_CHAT_LOADING = "FETCH_CHAT_LOADING";
export const FETCH_CHAT_SUCCESS = "FETCH_CHAT_SUCCESS";
export const FETCH_CHAT_ERROR = "FETCH_CHAT_ERROR";
export const SEND_MESSAGE_LOCAL = "SEND_MESSAGE_LOCAL";

export const UPDATE_NOTES_MESSAGE = "UPDATE_NOTES_MESSAGE";

export const FETCH_CHAT_UNREAD_COUNT_SUCCESS =
  "FETCH_CHAT_UNREAD_COUNT_SUCCESS";
export const FETCH_RESPONSE_COUNT_SUCCESS = "FETCH_RESPONSE_COUNT_SUCCESS";
export const FETCH_RESPONSIBLE_LIST_SUCCESS = "FETCH_RESPONSIBLE_LIST_SUCCESS";

export const FETCH_ALL_MESSAGES_SUCCESS = "FETCH_ALL_MESSAGES_SUCCESS";
export const FETCH_ALL_MORE_MESSAGES_SUCCESS =
  "FETCH_ALL_MORE_MESSAGES_SUCCESS";

/** Notifications  */
export const FETCH_NOTIFICATION_SUCCESS = "FETCH_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_LOADING = "FETCH_NOTIFICATION_LOADING";
export const FETCH_NOTIFICATION_ERROR = "FETCH_NOTIFICATION_ERROR";
export const FETCH_ALL_NOTIFICATION_SUCCESS = "FETCH_ALL_NOTIFICATION_SUCCESS";

/** custom message  */
export const FETCH_CUSTOM_MESSAGE_SUCCESS = "FETCH_CUSTOM_MESSAGE_SUCCESS";
export const FETCH_CUSTOM_MESSAGE_LOADING = "FETCH_CUSTOM_MESSAGE_LOADING";
export const FETCH_CUSTOM_MESSAGE_ERROR = "FETCH_CUSTOM_MESSAGE_ERROR";

/** voicemails  */
export const FETCH_VOICEMAILS_SUCCESS = "FETCH_VOICEMAILS_SUCCESS";
export const FETCH_VOICEMAILS_ERROR = "FETCH_VOICEMAILS_ERROR";
export const FETCH_VOICEMAILS_LOADING = "FETCH_VOICEMAILS_LOADING";
export const RESET_VOICEMAILS = "RESET_VOICEMAILS";
export const FETCH_MORE_VOICEMAILS_SUCCESS = "FETCH_MORE_VOICEMAILS_SUCCESS";
export const FETCH_MORE_VOICEMAILS_LOADING = "FETCH_MORE_VOICEMAILS_SUCCESS";
export const SET_VOICECHAT_PHONE_NO = "SET_VOICECHAT_PHONE_NO";
export const FETCH_VOICECHAT_LOADING = "FETCH_VOICECHAT_LOADING";
export const FETCH_VOICECHAT_SUCCESS = "FETCH_VOICECHAT_SUCCESS";
export const FETCH_VOICECHAT_ERROR = "FETCH_VOICECHAT_ERROR";

export const UPDATE_NOTES_VOICEMAIL = "UPDATE_NOTES_VOICEMAIL";

export const FETCH_VOICECHAT_UNREAD_COUNT_SUCCESS =
  "FETCH_VOICECHAT_UNREAD_COUNT_SUCCESS";

/** Pre-THEME Actions */
/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";
export const CHANGE_FONTSIZE = "CHANGE_FONTSIZE";

/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const LOGIN_USER_API_SUCCESS = "LOGIN_USER_API_SUCCESS";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const SYNC_USER_INFO = "SYNC_USER_INFO";
export const UPDATE_SELECTED_EMPLOYEE = "UPDATE_SELECTED_EMPLOYEE";

export const SELECT_ACTIVE_ACCOUNT = "SELECT_ACTIVE_ACCOUNT";

/* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS =
  "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

/** PREFERENCES */
export const FETCH_PREFERENCES_SUCCESS = "FETCH_PREFERENCES_SUCCESS";
export const FETCH_PREFERENCES_LOADING = "FETCH_PREFERENCES_LOADING";

/** TAGS */
export const FETCH_TAG_SUCCESS = "FETCH_TAG_SUCCESS";
export const FETCH_TAG_ERROR = "FETCH_TAG_ERROR";
export const FETCH_TAG_LOADING = "FETCH_TAG_LOADING";

/** Settings */
export const FETCH_EMPLOYEE_SUCCESS = "FETCH_EMPLOYEE_SUCCESS";
export const FETCH_BLOCKEDNUMBERS_SUCCESS = "FETCH_BLOCKEDNUMBERS_SUCCESS";
export const FETCH_VOICEMAILDESTINATION_SUCCESS =
  "FETCH_VOICEMAILDESTINATION_SUCCESS";
export const FETCH_AUDITLOGS_SUCCESS = "FETCH_AUDITLOGS_SUCCESS";
export const FETCH_PAYMENTINFO_SUCCESS = "FETCH_PAYMENTINFO_SUCCESS";

export const FETCH_SETTING_ERROR = "FETCH_SETTING_ERROR";
export const FETCH_SETTING_LOADING = "FETCH_SETTING_LOADING";

/** AI Assistant */
export const FETCH_AI_SETTINGS_SUCCESS = "FETCH_AI_SETTINGS_SUCCESS";
export const FETCH_AI_SETTINGS_LOADING = "FETCH_AI_SETTINGS_LOADING";
export const FETCH_AI_SETTINGS_ERROR = "FETCH_AI_SETTINGS_ERROR";
export const UPDATE_AI_SETTINGS_SUCCESS = "UPDATE_AI_SETTINGS_SUCCESS";

export const FETCH_CONVERSATION_AI_STATUS_SUCCESS =
  "FETCH_CONVERSATION_AI_STATUS_SUCCESS";
export const FETCH_CONVERSATION_AI_STATUS_LOADING =
  "FETCH_CONVERSATION_AI_STATUS_LOADING";
export const FETCH_CONVERSATION_AI_STATUS_ERROR =
  "FETCH_CONVERSATION_AI_STATUS_ERROR";

export const UPDATE_CONVERSATION_AI_STATUS_SUCCESS =
  "UPDATE_CONVERSATION_AI_STATUS_SUCCESS";
export const UPDATE_CONVERSATION_AI_STATUS_LOADING =
  "UPDATE_CONVERSATION_AI_STATUS_LOADING";
export const UPDATE_CONVERSATION_AI_STATUS_ERROR =
  "UPDATE_CONVERSATION_AI_STATUS_ERROR";

export const FETCH_GOOGLE_CALENDARS_LOADING = "FETCH_GOOGLE_CALENDARS_LOADING";
export const FETCH_GOOGLE_CALENDARS_SUCCESS = "FETCH_GOOGLE_CALENDARS_SUCCESS";
export const FETCH_GOOGLE_CALENDARS_ERROR = "FETCH_GOOGLE_CALENDARS_ERROR";

export const UPDATE_GOOGLE_CALENDAR_NAME = "UPDATE_GOOGLE_CALENDAR_NAME";
export const DELETE_GOOGLE_CALENDAR = "DELETE_GOOGLE_CALENDAR";

/* CHAT APP*/
// export const CHAT_GET_CONTACTS = "CHAT_GET_CONTACTS";
// export const CHAT_GET_CONTACTS_SUCCESS = "CHAT_GET_CONTACTS_SUCCESS";
// export const CHAT_GET_CONTACTS_ERROR = "CHAT_GET_CONTACTS_ERROR";
// export const CHAT_GET_CONVERSATIONS = "CHAT_GET_CONVERSATIONS";
// export const CHAT_GET_CONVERSATIONS_SUCCESS = "CHAT_GET_CONVERSATIONS_SUCCESS";
// export const CHAT_GET_CONVERSATIONS_ERROR = "CHAT_GET_CONVERSATIONS_ERROR";
// export const CHAT_ADD_MESSAGE_TO_CONVERSATION =
//   "CHAT_ADD_MESSAGE_TO_CONVERSATION";
// export const CHAT_CREATE_CONVERSATION = "CHAT_CREATE_CONVERSATION";
// export const CHAT_SEARCH_CONTACT = "CHAT_SEARCH_CONTACT";
// export const CHAT_CHANGE_CONVERSATION = "CHAT_CHANGE_CONVERSATION";

export * from "./auth.action";
export * from "./contact.action";
export * from "./custommessage.action";
export * from "./menu.action";
export * from "./message.action";
export * from "./notification.action";
export * from "./settings.action";
export * from "./voicemail.action";
export * from "./platform.action";
export * from "./common.action";
export * from "./preferences.action";
export * from "./tag.action";
// export * from "./settings/actions";
// export * from "./auth/actions";
// export * from "./chat/actions";
